// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import {FormInput} from '@homeaway/react-form-components';
import FormSelect from '@homeaway/react-form-select';
import {SVGIcon} from '@homeaway/react-svg';
import Modal from '@homeaway/react-modal';

// Relative Imports
import './VatInformation.less';
import Address from '../Address/Address';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import alertIconWhite from '../../images/alert-icon-white';
import AlertInfoBox from './AlertInfoBox/AlertInfoBox';
import {processTranslation} from '../utils/commonUtil';
import AlertBox from '../Alert/Alert';
import SubHead from '../SubHead/SubHead';
import {
    addressFormErrorMapper,
    addressFormValuesMapper,
    handleFormFields,
    handleFormFieldsOnBlur
} from '../utils/addressUtil';

class VatInformation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    handleFields = (event) => {
        return handleFormFields(event, this.props);
    };

    handleFieldsBlur = (event) => {
        return handleFormFieldsOnBlur(event, this.props);
    };

    getVatInfoModalView = (alertBoxHeader, alertBoxContent) => {
        return (
            <div className="content-col alert-info-holder-top">
                <Modal id="alert-info-modal" className="alert-info-modal" isOpen={this.props.infoIconClickedStatus} >
                    <AlertInfoBox translations={this.props.translations} closeInfoIcon={this.props.closeInfoIcon} alertBoxHeader={alertBoxHeader} alertBoxContent={alertBoxContent}/>
                </Modal>
            </div>
        );
    };

    getVatInfoDesktopView = (alertBoxHeader, alertBoxContent) => {
        return (
            <div className="content-col-alert alert-info-holder info-icon-holder">
                <AlertInfoBox translations={this.props.translations} closeInfoIcon={this.props.closeInfoIcon} alertBoxHeader={alertBoxHeader} alertBoxContent={alertBoxContent}/>
            </div>
        );
    };

    render() {
        const {
            translations,
            serviceError,
            handleFormSubmit,
            vatCountryOptions,
            companyLocationName,
            handleVatInfoCountryChange,
            vatInfoCountryValue,
            vatInfoCountryError,
            onVatInfoCountryBlur,
            handleVatNumberChange,
            vatNumberValue,
            vatNumberError,
            onVatNumberBlur,
            vatRegionCodeOptions,
            vatRegionCodeValue,
            handleVatRegionCodeChange,
            onVatRegionCodeBlur,
            vatAddressCountryValue,
            handleAlertDismiss,
            enableButton,
            handleInfoIcon,
            infoIconClickedStatus,
            triggerEdapEventOnFocus,
            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose
        } = this.props;
        const vatKey = translations['ipmob.vat_page.vat_key'];
        const stringToReplace = [companyLocationName, vatKey];
        const alertBoxHeader = (<h6>{translations['ipmob.vat_page.alert_box.heading']}</h6>);

        const alertBoxContent = (<div>
            {
                <p>{translations['ipmob.vat_page.alert_box.content_1']}</p>
            }
        </div>);

        return (
            <div id="vatInformation" className="vat-information">
                <div className="vat-container">
                    <SubHead
                        translations={translations}
                        handleSaveAndFinishOnClick={handleSaveAndFinishOnClick}
                        isSaveModalOpen={isSaveModalOpen}
                        handleSaveModalClose={handleSaveModalClose}
                    />
                    {
                        (serviceError)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="wrapper">
                        <div className="content-col-text panel-head">
                            <h1 className="head">{processTranslation(translations['ipmob.vat_page.heading'], stringToReplace)}</h1>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col-text sub-head2">
                            <h3>{processTranslation(translations['ipmob.vat_page.sub_heading_1'], stringToReplace)}</h3>
                        </div>
                    </div>
                    <div className="wrapper">
                        {
                            infoIconClickedStatus
                                ?
                                this.getVatInfoModalView(alertBoxHeader, alertBoxContent)
                                : null
                        }
                    </div>
                    <div className="wrapper">
                        <div className="content-col-form form-holder">
                            <div className="wrapper">
                                <div className="content-col-form form-holder">
                                    <FormSelect
                                        className={this.props.useRvsCountries ? 'vat-help-format' : ''}
                                        id="Vat.InformationCountry"
                                        name="Country selected - VAT"
                                        items={vatCountryOptions}
                                        label={translations['ipmob.address.label_1']}
                                        value={vatInfoCountryValue}
                                        onChange={handleVatInfoCountryChange}
                                        errorMsg={translations[vatInfoCountryError]}
                                        onBlur={onVatInfoCountryBlur}
                                    />
                                    {this.props.useRvsCountries && (
                                        <span className="vat-help-wrapper">
                                            <SVGIcon id="alert-icon-svg" className="alert-icon vat-help-icon" markup={alertIconWhite}/>
                                            <span className="vat-country-help">{translations['ipmob.vat_page.country_help']}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-form form-holder">
                                    {(vatRegionCodeOptions.length) ?
                                        <FormSelect
                                            id="Vat.RegionCode"
                                            name="Region code selected - VAT"
                                            items={vatRegionCodeOptions}
                                            label={translations['ipmob.vat_page.label_1']}
                                            value={vatRegionCodeValue}
                                            onChange={handleVatRegionCodeChange}
                                            onBlur={onVatRegionCodeBlur}
                                        /> : null
                                    }
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="vat-alert-box">
                                    <div className="content-col-form form-holder">
                                        <FormInput
                                            id="Vat.Number"
                                            type="text"
                                            name="VAT Number"
                                            label={translations['ipmob.vat_page.label_2']}
                                            value={vatNumberValue}
                                            onChange={handleVatNumberChange}
                                            errorMsg={translations[vatNumberError]}
                                            onFocus={triggerEdapEventOnFocus}
                                            onBlur={onVatNumberBlur}
                                            maxLength="64"
                                            rightContent={
                                                <div onClick={handleInfoIcon}>
                                                    <SVGIcon id="alert-icon-svg" className="alert-icon" markup={alertIconWhite}/>
                                                </div>
                                            }
                                            contentClickable
                                        />
                                    </div>
                                    {
                                        infoIconClickedStatus
                                            ? this.getVatInfoDesktopView(alertBoxHeader, alertBoxContent)
                                            : null
                                    }
                                </div>
                            </div>
                            <form id="addressForm" role="form">
                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col-text sub-head2">
                                            <h3>{processTranslation(translations['ipmob.vat_page.sub_heading_2'], stringToReplace)}</h3>
                                        </div>
                                    </div>
                                    <Address
                                        countryList={vatCountryOptions}
                                        country={vatAddressCountryValue}
                                        translations={translations}
                                        addressFormValues={addressFormValuesMapper(this.props)}
                                        addressFormErrors={addressFormErrorMapper(this.props)}
                                        handleFieldsOnBlur={this.handleFieldsBlur}
                                        handleAddressFields={this.handleFields}
                                        handleFieldsOnFocus={triggerEdapEventOnFocus}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="continue-btn-wrapper" style={infoIconClickedStatus ? {marginTop: 89} : null}>
                        <ContinueButtonHolder
                            enableContinueButton={enableButton}
                            translations={translations}
                            handleContinueButtonClick={handleFormSubmit}
                            continueButtonId={'vatPageContinueBtn'}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default VatInformation;
